@if (!validFrom() && !validUntil()) {
  <span>-</span>
}

@if (validFrom(); as validFrom) {
  @let validFromDate = validFrom | date: 'dd.MM.yyyy';
  <span [title]="validFromDate">{{ validFromDate }}</span>
}

@if (validUntil(); as validUntil) {
  @let validUntilDate = validUntil | date: 'dd.MM.yyyy';
  <span [title]="validUntilDate">{{ ' - ' + validUntilDate }}</span>
}
